import 'antd/dist/antd.less';
import '@lcsc-design/ui/styles.css';
import '../styles/ant-reset.less';
import '../styles/global.css';

import { useEffect } from 'react';

import dataplus from '@lcsc/data-plus';
import { env } from '@lcsc-ui/utils/baseUrl';
import { message } from 'antd';

const MyNextApp = ({ Component, pageProps }) => {
  useEffect(() => {
    try {
      dataPlusInit();
      // monitorInit();
    } catch (error) {
      console.log(error);
      //
    }
    message.config({
      top: 150, // 距离顶部距离，单位px
      duration: 3, // 多少秒后消失
      maxCount: 5, // 同一页面最多展示多少个
    });
  }, []);

  // 监控sdk开关
  function dataPlusInit() {
    // 初始化埋点
    if (typeof window !== 'undefined') {
      let dataplus_url = 'https://collector.szlcsc.com';
      if (['fat', 'dev', 'uat'].includes(env)) {
        dataplus_url = `https://${env}collector.szlcsc.com`;
      } else if (['local'].includes(env)) {
        dataplus_url = `https://devcollector.szlcsc.com`;
      }
      dataplus?.init({
        c_url: `${dataplus_url}/collect.js`,
        pf: 'pc',
      });
      console.log('埋点初始化成功');
    }
  }

  // 前端监控
  // function monitorInit() {
  //   if (window.monitor && typeof window.monitor.init === 'function') {
  //     let monitor_url = 'https://monitor.szlcsc.com/monitor';
  //     if (['fat', 'dev', 'uat'].includes(env)) {
  //       monitor_url = `https://${env}monitor.szlcsc.com/monitor`;
  //     } else if (['local'].includes(env)) {
  //       monitor_url = `https://devmonitor.szlcsc.com/monitor`;
  //     }
  //     window.monitor.init({
  //       url: monitor_url,
  //       appID: 'nextjs-smt-app',
  //       getUserId: function () {
  //         return window.customerCode;
  //       },
  //     });
  //     console.log('前端监控初始化成功');
  //   }
  // }

  return (
    <div id="lc-smt">
      <Component {...pageProps} />
    </div>
  );
};

export default MyNextApp;
